import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, useBreakpointValue, useDisclosure } from "@chakra-ui/react";
import { createElement, useEffect } from "react";
import { BsCheckCircle, BsXCircle } from 'react-icons/bs';
import { Button } from '../../components/button/Button';
import { lang } from "../../Utils";

const Success = () => <BsCheckCircle />
const Error = () => <BsXCircle />

const Variant = {
  success: Success,
  error: Error
}

const DialogMessage = ({ isOpen, onClose, title, variant, children }) => {
  
  const size = useBreakpointValue({ base: 'sm', sm: 'full', md: 'sm', lg: 'sm', xl: 'sm', xxl: 'sm' })
 
  return (<>
    <Modal isOpen={isOpen} onClose={onClose} size={size}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader className="bf-modal-header">{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody className="bf-modal-body bf-modal-message">
          <div>
            {createElement(Variant[variant])}
          </div>
          <center>
            {children}
          </center>
          <div class="bf-modal-actions">
            <Button variant="default" onClick={onClose}>{lang('Close')}</Button>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  </>
  )
}

export default DialogMessage;